import React from 'react';
import { ChevronDown, LucideProps } from 'lucide-react';

/**
 * Standardized ChevronDown icon component.
 * Wraps the lucide-react ChevronDown icon for consistent usage across the app.
 */
export const ChevronDownIcon: React.FC<LucideProps> = (props) => {
  return <ChevronDown {...props} />;
};
